// Widget Scripts
import countdownWidget from "./js/widgets/countdownWidget.js";
import headerButtons from "./js/widgets/headerButtons.js";

// Custom Theme Scripts
import "./js/localjs.js";

// Initialize Homepage Widgets if is required
$(document).ready(function () {
  headerButtons();
  countdownWidget();
});
